import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from './services/auth/auth.service';
import { NavBarService } from './services/navbar/navbar.service';
import { ThemeVarsService } from './shell/theme-vars.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'configurator_app';
  loading = false;

  constructor(private _authService: AuthService, private navService: NavBarService, private route: ActivatedRoute, private router: Router, private themeVars: ThemeVarsService) { }

  ngOnInit(): void {
    this.themeVars.start();
    this._authService.autoLogin();
    this.navService.loading$.subscribe(response => {
      this.loading = response
    });

    // Try to get token from ActivatedRoute
    this.route.queryParams.subscribe(params => {
      let token = params['token'];

      // Fallback: Check window.location.search directly in case Router redirect stripped it
      if (!token) {
        const urlParams = new URLSearchParams(window.location.search);
        token = urlParams.get('token');
      }

      if (token) {
        this._authService.exchangeToken(token).subscribe({
          next: (user) => {
            // Same entry point as a normal login — /home now requires a
            // project, which the mode screen is what creates.
            this.router.navigate(['/mode']);
          },
          error: (err) => console.error('Auto-login failed', err)
        });
      }
    });
  }

}
